module.exports = __webpack_public_path__ + "img/ic_hide.b3b80efb.svg";